import type { LocationType } from 'pages/my-calendars/enums'

export const getClearCalendarRowDescription = (prop: LocationType) => {
    switch (prop) {
        case 'region':
            return 'Все даты для данного региона будут очищены'

        case 'cluster':
            return 'Все даты для данного города будут очищены'

        case 'store':
            return 'Все даты для данного магазина будут очищены'
        default:
            'Все даты для данного поля будут очищены'
    }
}
